<div class="homeSideBar">
    <div class="homeLoginArea">
        <span class="homeSideBarHeader homeProfileName">{{userName}}</span>
        <div class="homeProfileArea">
            <div class="homeProfileImageArea">
                <img src="{{userProfileImageSrc}}">
            </div>
        </div>
        <div class="homeProfileButtons">
            <a
                (click)="onClickProfile()"
                class="homeProfileBtn" 
                type="button" 
                [innerHTML]="'ACCOUNT_ACCOUNT_PROFILE_BUTTON' | translate"
            ></a>
            <!-- <a data-toggle="modal" data-target="#cardAndFavoritesModal"  class="homeCardsFavouritesBtn" type="button" [innerHTML]="'ACCOUNT_ACCOUNT_CARDS_AND_FAVORITES_BUTTON' | translate"></a> -->
        </div>
    </div>
    <app-download-app></app-download-app>
</div>